import React, { Fragment } from "react";
import {Row, Col, Card, Button, Accordion} from "react-bootstrap";
import ShowVideo from "../components/ShowVideo";
import QuizIntroCreativity from "../components/quiz/QuizIntroCreativity";
import QuizAssociativeThinking from "../components/quiz/QuizAssociativeThinking";
import QuizPatentSearch from "../components/quiz/QuizPatentSearch";
import QuizPitchingIdea from "../components/quiz/QuizPitchingIdea";
import ObjectPicker from "../components/ObjectPicker";


const SubProblem = ({ problem }) => {

 var comparray = "";
 var compobjarray = "";
 var headerStyle = {color: '#c87137'};

 if (problem?.components){
   comparray = problem?.components.split(', ');
   compobjarray = comparray.map(pair => pair.split(":"));
 }

 if (problem?.solutionid){
   headerStyle = {color: '#808000'}
 }
 

 const quizzes = {
   QuizIntroCreativity: QuizIntroCreativity,
   QuizAssociativeThinking: QuizAssociativeThinking,
   QuizPatentSearch: QuizPatentSearch,
   QuizPitchingIdea: QuizPitchingIdea
 }


   return(
      <Fragment>
          <Accordion.Item eventKey={problem.problemid}>
            <Accordion.Header> <span style={headerStyle}> Task #{problem.ordernum}: {problem.title} </span></Accordion.Header>
            <Accordion.Body className="p-5"> 
               <div dangerouslySetInnerHTML={{__html:problem.description}} />
               {
                     compobjarray?.map((item) => {
                        if(item[0]=="video"){
                           return (<ShowVideo embedid={item[1]} />);
                        }
                        if (item[0]=="quiz"){
                           const QuizComponent = quizzes[item[1]];
                           return (<QuizComponent pb={problem} />);
                        }
                        if (item[0]=="objectPicker"){                     
                           return (<ObjectPicker limit={item[1]} pb={problem}/>);
                        }
                     }
                     )  
               }
               {
                  problem.solutionid ? (<p className="lead" style={{color: '#808000'}}> <strong> You have already completed this task step! </strong></p>) : (<p></p>)
               }
            
            </Accordion.Body>
         </Accordion.Item>
      </Fragment>
   );


};

export default SubProblem;